export const getDetailService = (product: number, company: number) => {
  return fetch(
    `/api/custom/documentOfferQuestion/service/${product}?company=${company}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const addNewCustomOfferPrice = (data: {
  projectName?: string;
  realizationNumber?: string;
  startDate?: string;
  endDate?: string;
  price?: number;
  description?: string;
  accountCompany: number;
  product: number;
  service: number;
  commission: number;
}) => {
  return new Promise((res, rej) => {
    customOfferPriceEditor()
      .then((tst) => {
        tst.json().then((e) => {
          fetch(`/api/custom_offer_price_lists`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ data: data }),
          })
            .then((e) => {
              res(e);
            })
            .catch((e) => {
              rej(e);
            });
        });
      })
      .catch((e) => {
        rej(e);
      });
  });
};

export const getCustomOfferPriceList = (additionalData?: string[]) => {
  return fetch(
    `/api/custom_offer_price_lists?setting[with_relations]=1&${additionalData?.join(
      "&"
    )}&extra_fields=is_active`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const deleteCustomOfferPrice = (id: number) => {
  return fetch(`/api/custom_offer_price_lists/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const customOfferPriceEditor = () => {
  return fetch(`/api/custom/offer_price/set_editor`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getAutoselectCommissionByQuery = (query: string) => {
  return fetch(
    `/api/commissions/autoselect?fields=commissionNumber,name&filter[_q][hasText]=${query}&page[limit]=20&extra_fields=attributes&setting[with_relations]=true`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
